// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".org-tree-node-label-inner {\n  border: 1px solid #fff;\n}\n.org-tree-node-label-inner:hover {\n  border: 1px solid #1890ff;\n}", ""]);
// Exports
module.exports = exports;
